<template>
  <div>
    <Layout :pagetitle="$t('Company')">
      <Table
        :title="$t('Company')"
        :items="companies"
        :columns="columns"
        :totalItems="totalItems"
        :showButtons="true"
        :showCreateButton="false"
        :searchable="true"
        :editable="true"
        :removable="false"
        :showPagination="true"
        @onSearch="onSearch"
        @onEdit="editCompany"
        @onChangePage="changePage"
      />
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';
import authService from '@/services/auth.services';

export default {
  components: { Layout, Table },
  data() {
    return {
      search: '',
      page: 1,
      totalItems: 0,
      columns: [
        {
          key: 'name',
          label: this.$t('Name')
        },
        {
          key: 'require_mfa',
          label: 'Require MFA',
          formatter: (value) => (value ? this.$t('Yes') : this.$t('No'))
        }
      ],
      companies: []
    };
  },
  mounted() {
    const usr = authService.getLoggedUser();
    if (usr?.root !== true) {
      this.$router.push({ name: '404' });
      return;
    }
    this.getCompanies();
  },
  methods: {
    changePage(page) {
      this.page = page;
      this.getCompanies();
    },
    getCompanies() {
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get('api/company/all', { search: this.search, page: this.page })
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          this.companies = res.data?.results || [];
          this.totalItems = res.data.total;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.error('Error loading companies:', err);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Error loading companies')
          });
        });
    },
    editCompany(company) {
      this.$router.push({
        name: 'companyUpdate',
        params: {
          id: company.id
        }
      });
    },
    onSearch(search = '') {
      this.search = search;
      this.page = 1;
      this.getCompanies();
    }
  }
};
</script>

<style></style>
